import React, { useState, useRef, useEffect } from 'react';
import { Button, Card, Col, Row, Modal, Image } from 'react-bootstrap';
import { Check } from 'react-feather';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import IDIQ from '../../assets/img/providers/idiq-logo.png';
import TrulyID from '../../assets/img/providers/truly-id-logo.png';
import SmartCredit from '../../assets/img/providers/smart-credit-logo.png';
import Loader from '../../components/Loader';
import ReportUpload from '../report_upload/ReportUpload';
import $ from 'jquery';
import 'jquery-confirm/js/jquery-confirm';
import 'jquery-confirm/css/jquery-confirm.css';
import OnboardingSteps from '../../components/new/OnboardingSteps';
import { useDispatch } from 'react-redux';
import { callUserActvity } from '../../redux/slices/CommonSlice';
import WelcomeBot from './welcome-bot.png';

const ChooseReport = ({ gotoDashboard }) => {
  const handleBeforeUnload = event => {
    // Display a confirmation dialog
    event.preventDefault();
    event.returnValue = 'Are you sure you want to leave this page?';
  };

  useEffect(() => {
    // Attach the event listener to the window object
    window.addEventListener('beforeunload', handleBeforeUnload);

    // Clean up the event listener when the component is unmounted
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []); // Empty dependency array ensures the effect runs only once

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showReportModal, setShowReportModal] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [showIDIQSignup, setShowIDIQSignup] = useState(false);
  const [reportData, setReportData] = useState({
    report_type: '',
    report_content: '',
  });

  const reportLoginButton = () => {
    dispatch(callUserActvity('Click on report upload button'));
    setShowLoginModal(true);
  };

  const handleReportClick = () => {
    setShowReportModal(true);
  };

  const reportDataRef = useRef({
    report_type: '',
    report_content: '',
  });

  const videoId = 'iqQhNAbBhWU'; // the ID of the YouTube video

  const opts = {
    playerVars: {
      modestbranding: 1,
    },
  };

  const showSignupModal = (company, report_type, url) => {
    $.confirm({
      title: `${company} Signup`,
      content: `You are going to create an account with ${company}, when you have done so, please come back here and add your login info`,
      type: 'blue',
      buttons: {
        ok: {
          text: 'Okay',
          btnClass: 'btn btn-outline-primary',
          keys: ['enter'],
          action: function () {
            dispatch(callUserActvity(`Show Signup with ${company}`));
            setReportData({ ...reportData, report_type });
            reportLoginButton();
            window.open(url, '', 'height=800,width=800');
          },
        },
        // cancel: function(){}
      },
    });
  };

  function goToReportReader() {
    // navigate to a new page
    navigate('/get-start-disputely');
  }

  return (
    <React.Fragment>
      <Helmet title='Choose Report' />
      <style>
        {`
          .steps {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 2rem;
            position: relative;
          }
          .step-button {
            width: 30px;
            height: 30px;
            border-radius: 50%;
            border: none;
            background-color: var(--bs-light) !important;
            transition: .4s;
          }
          .step-button[aria-expanded="true"] {
            width: 25px;
height: 25px;
font-size: 12px;
          }
          .done {
            background-color: var(--prm-color);
            color: #fff;
          }
          .step-item {
            z-index: 10;
            text-align: center;
            margin-top: 1.5rem;
          }
          #progress {
            -webkit-appearance: none;
            position: absolute;
            width: 100%;
            z-index: 5;
            border: #C8CCDF dashed;
            border-width: 3px 0px 0px 0px;
            top: 6.75rem;
          }
          /* to customize progress bar */

          #progress::-webkit-progress-value {
            background-color: var(--prm-color);
            transition: .5s ease;
          }
          #progress::-webkit-progress-bar {
            background-color: var(--prm-gray);
          }
          .step-title {
            width: 120px;
            color: #7C84A5;
            font-weight: 400;
            text-align: center;
            margin-bottom:1.5rem;
          }
          .completed .step-title {
            text-align: center;
            font-weight: 500;
            color: #000E4E
          }
          .active .step-title {
            font-weight: 500;
            color: #0076FF
          }

         .active .step-button {
            position: relative;
          }

        .active .step-button::after {
          content: '';
          position: absolute;
          top: -1px;
          left: -3%;
          transform: translate(-50%, -50%);
          width: 30px;
          height: 30px;
          border-radius: 50%;
          background-color: var(--bs-primary);
          animation: sonar 2s infinite;
          z-index: -1;
        }

          @keyframes sonar {
            0% {
              opacity: 1;
              transform: scale(0.5);
            }
            100% {
              opacity: 0;
              transform: scale(1.5);
            }
          }

          .modal-content {
              border-radius: var(--bs-border-radius-xl) !important;
          }

        .ytp-ce-element,
        .ytp-ce-element .ytp-ce-channel-logo,
        .ytp-ce-element .ytp-ce-channel-title,
        .ytp-ce-element .ytp-ce-watermark {
          /* Hide the YouTube branding */
          display: none !important;
        }

iframe {

  border-radius: 1rem !important;

}

 @media (max-width: 1284px) {
                #progress {
                  width: 980px !important;
                }
             
              }

              @media (max-width: 992px) {
                #progress {
                  width: 980px !important;
                }
             
              }

              @media (max-width: 768px) {
                #progress {
                  width: 980px !important;
            
              }
          `}
      </style>
      <div className='container-fluid container-fluid-1335 mb-5 overflow-hidden'>
        <div className='row'>
          <div className='col-lg-12'>
            <h3>Disputes creating status</h3>
          </div>
        </div>
        <OnboardingSteps activeStepButtonLeft='-2px' progressComplete='0' activeStep={1} />

        <Row className='row d-flex justify-content-between align-items-center my-5'>
          <Col xs='12'>
            <h3 className='h1'>Welcome!</h3>
          </Col>
          <div className='col-lg-6'>
            <div className='d-flex flex-md-row flex-column align-items-center row'>
              <div className='col-4'>
                <Image src={WelcomeBot} className='w-100' alt='welcome bot' />
              </div>
              <div className='col-12 col-md-8 mb-5 mb-md-0'>
                <div className='text'>
                  <div className='text-medium-18'>Great Job you have completed creating your account!</div>
                  <div className='text-medium-18'>In order to create your Artifical Intelligence (AI) generated custom Dispute letters, we need to access your credit reports. Dispute.ly has partnered with TOP Credit Monitoring Sites to provide you the type of reports that are compatible with our FREE AI Credit Repair Tool!</div>
                  <div className='text-dark-blue'> Why do you need to use AI Compatible reports? Watch the video to learn more.</div>
                </div>
                <div className='why-do-you-need-to-use-ai-comp-parent'></div>
              </div>
            </div>
          </div>

          <style>
            {`

            @media (max-width: 767.98px) {

              #reportsvideo {
            width: 100%;
            margin:auto;
              }
            }
  `}
          </style>
          <div className='col-lg-6 w-md-100 rounded-4'>
            <iframe id='reportsvideo' className='ms-auto d-block' width='560' height='315' src='https://www.youtube.com/embed/p2OMMDgiHug' title='YouTube video player' frameborder='0' allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share' allowfullscreen></iframe>
          </div>
        </Row>
        <Row>
          <div className='col-lg-12'>
            {' '}
            <div className='identity'>
              <div className='budge btn btn-primary btn-lg px-5 w-auto disabled bg-primary opacity-100'>
                <div className='ill-do-this'>Best All Around Choice</div>
              </div>
              <Card className='identity-iq'>
                <Card.Header className='d-flex justify-content-center pt-5 border-0 bg-white'>
                  <img src={IDIQ} alt='idiq logo' style={{ width: '275px' }} />
                </Card.Header>
                <Card.Body className='w-100 row flex-row align-items-center'>
                  <div className='col-md-4 col-12 d-flex flex-column mx-auto mb-5 mt-3 align-self-stretch'>
                    <div className='list-items2 mb-5'>
                      <div className='item13'>
                        <div className='tick6'>
                          <Check width={15} height={24} strokeWidth={3} />
                        </div>
                        <div className='text-regular-16 text-gray-200'>{`Monthly 3-Bureau Credit Reports & Scores`}</div>
                      </div>
                      <div className='item13'>
                        <div className='tick6'>
                          <Check width={15} height={24} strokeWidth={3} />
                        </div>
                        <div className='text-regular-16 text-gray-200'>3-Bureau Credit Report Monitoring</div>
                      </div>
                      <div className='item13'>
                        <div className='tick6'>
                          <Check width={15} height={24} strokeWidth={3} />
                        </div>
                        <div className='text-regular-16 text-gray-200'>$1 Million Stolen Funds Reimbursement</div>
                      </div>
                      <div className='item13'>
                        <div className='tick6'>
                          <Check width={15} height={24} strokeWidth={3} />
                        </div>
                        <div className='text-regular-16 text-gray-200'>Enhanced Credit Report Monitoring</div>
                      </div>
                      <div className='item13'>
                        <div className='tick6'>
                          <Check width={15} height={24} strokeWidth={3} />
                        </div>
                        <div className='text-regular-16 text-gray-200'>Alerts on Crimes Committed in Your Name</div>
                      </div>
                      <div className='item13'>
                        <div className='tick6'>
                          <Check width={15} height={24} strokeWidth={3} />
                        </div>
                        <div className='text-regular-16 text-gray-200'>Score Change Alerts</div>
                      </div>
                      <div className='item13'>
                        <div className='tick6'>
                          <Check width={15} height={24} strokeWidth={3} />
                        </div>
                        <div className='text-regular-16 text-gray-200'>{`Credit Scores Simulation & Tracker`}</div>
                      </div>
                      <div className='item13'>
                        <div className='tick6'>
                          <Check width={15} height={24} strokeWidth={3} />
                        </div>
                        <div className='text-regular-16 text-gray-200'>$25K ID Theft Insurance - Family Protection</div>
                      </div>
                      <div className='item13'>
                        <div className='tick6'>
                          <Check width={15} height={24} strokeWidth={3} />
                        </div>
                        <div className='text-regular-16 text-gray-200'>{`Fraud Restoration with LPOA `}</div>
                      </div>
                    </div>
                    <Button
                      className='btn btn-lg btn-primary w-100 mt-auto'
                      onClick={() => {
                        setReportData({ ...reportData, report_type: '5' });
                        reportLoginButton();
                      }}>
                      <div>I already have an account</div>
                    </Button>
                  </div>
                  <div className='divider' />
                  <div className='col-md-4 col-12 d-flex flex-column mx-auto mb-5 mt-3 align-self-stretch'>
                    <div className='d-flex flex-column'>
                      <div className='text-block mb-4'>
                        <div className='text-medium-18 fw-medium'>Report Advantage</div>
                        <div className='text-regular-16 text-gray-200'>Identity IQ’s comprehensive credit reports provide extensive and detailed information that can be used to compile the most effective disputes.</div>
                      </div>
                      <div className='text-block mb-4'>
                        <div className='text-medium-18 fw-medium'>Advanced A.I.</div>
                        <div className='text-regular-16 text-gray-200'>Our advanced artificial intelligence and machine learning algorithms allow us to analyse large amounts of data and make accurate predictions, improving the efficiency.</div>
                      </div>
                      <div className='text-block mb-5'>
                        <div className='text-medium-18 fw-medium'>Streamlined Results</div>
                        <div className='text-regular-16 text-gray-200'>By using Identity IQ’s reports with our system, we can streamline the process of uploading reports after each round of disputes has been-completed, minimising delays and providing quicker results.</div>
                      </div>
                    </div>
                    <button onClick={() => showSignupModal('Identity IQ', '5', 'https://www.identityiq.com/creditpreferred.aspx?offercode=431280NE')} className='btn btn-lg btn-outline-primary w-100 mt-auto'>
                      <div className='text-normal-16'>Sign up with Identity IQ</div>
                    </button>
                    {/* <button
                      type="button"
                      onClick={() => setShowIDIQSignup(true)}
                      className="btn btn-lg btn-outline-primary w-100 mt-auto"
                    >
                      <div className="text-normal-16">
                        Sign up with Identity IQ
                      </div>
                    </button> */}
                  </div>
                </Card.Body>
              </Card>
            </div>
          </div>
        </Row>
        <div className='row mt-5'>
          <div className='col-lg-12'>
            <Card className='h-100 rounded-4'>
              <Card.Header className='d-flex justify-content-center pt-5 border-0 bg-white rounded-4'>
                <img src={SmartCredit} alt='smart credt logo' style={{ width: '275px' }} />
              </Card.Header>
              <Card.Body className='w-100 d-flex flex-row align-items-center'>
                <div className='list-items2 mx-5 my-3 mx-auto align-self-stretch w-75  mb-5'>
                  <div className='item13'>
                    <div className='tick6'>
                      <Check width={15} height={24} strokeWidth={3} />
                    </div>
                    <div className='text-regular-16 text-gray-200'>ScoreTracker: Monitor and track credit scores over time</div>
                  </div>
                  <div className='item13'>
                    <div className='tick6'>
                      <Check width={15} height={24} strokeWidth={3} />
                    </div>
                    <div className='text-regular-16 text-gray-200'>ScoreBuilder: Improve credit scores with personalised recommendations</div>
                  </div>
                  <div className='item13'>
                    <div className='tick6'>
                      <Check width={15} height={24} strokeWidth={3} />
                    </div>
                    <div className='text-regular-16 text-gray-200'>ScoreBoost: Increase credit scores with customised tips and tricks</div>
                  </div>
                  <div className='item13'>
                    <div className='tick6'>
                      <Check width={15} height={24} strokeWidth={3} />
                    </div>
                    <div className='text-regular-16 text-gray-200'>MoneyManager: Manage and budget finances with online tools</div>
                  </div>
                  <div className='item13'>
                    <div className='tick6'>
                      <Check width={15} height={24} strokeWidth={3} />
                    </div>
                    <div className='text-regular-16 text-gray-200'>Smart Credit Report: Comprehensive credit report analysis and interpretation</div>
                  </div>
                  <div className='item13'>
                    <div className='tick6'>
                      <Check width={15} height={24} strokeWidth={3} />
                    </div>
                    <div className='text-regular-16 text-gray-200'>Credit Scores Simulation &amp; Tracker</div>
                  </div>
                  <div className='item13'>
                    <div className='tick6'>
                      <Check width={15} height={24} strokeWidth={3} />
                    </div>
                    <div className='text-regular-16 text-gray-200'>$1 Million Fraud Insurance: Coverage for financial losses due to fraud</div>
                  </div>
                  <div className='item13'>
                    <div className='tick6'>
                      <Check width={15} height={24} strokeWidth={3} />
                    </div>
                    <div className='text-regular-16 text-gray-200'>PrivacyMaster: Protect personal information and guard against identity theft</div>
                  </div>
                  <Col xs='12' md='12' className='d-flex flex-md-row flex-column justify-content-between mx-auto gap-6 mt-5'>
                    <Button
                      className='btn btn-lg btn-primary mt-auto w-100'
                      onClick={() => {
                        setReportData({ ...reportData, report_type: '6' });
                        reportLoginButton();
                      }}>
                      <div>I already have an account</div>
                    </Button>
                    <Button className='btn btn-lg mt-auto w-100' onClick={() => showSignupModal('Smart Credit', '6', 'https://www.smartcredit.com/?PID=52188')} variant='outline-primary' size='lg'>
                      <div>Sign up for Smart Credit</div>
                    </Button>
                  </Col>
                </div>
              </Card.Body>
            </Card>
          </div>

          {/* <div className='col-lg-6'>
            <Card className='h-100 rounded-4'>
              <Card.Header className='d-flex justify-content-center pt-5 border-0 bg-white rounded-4'>
                <img src={TrulyID} alt='trulyID logo' style={{ width: '160PX' }} />
              </Card.Header>
              <Card.Body className='w-100 d-flex flex-row align-items-center'>
                <div className='list-items2 mx-5 my-3 mx-auto align-self-stretch w-75'>
                  <div className='item13'>
                    <div className='tick6'>
                      <Check width={15} height={24} strokeWidth={3} />
                    </div>
                    <div className='text-regular-16 text-gray-200'>Secure and Plus plans include annual credit reports and Vantage Scores from one or three bureaus</div>
                  </div>
                  <div className='item13'>
                    <div className='tick6'>
                      <Check width={15} height={24} strokeWidth={3} />
                    </div>
                    <div className='text-regular-16 text-gray-200'>100% U.S. - based customer service team</div>
                  </div>
                  <div className='item13'>
                    <div className='tick6'>
                      <Check width={15} height={24} strokeWidth={3} />
                    </div>
                    <div className='text-regular-16 text-gray-200'>Daily credit report monitoring, user-friendly dashboard, and identity theft protection and monitoring</div>
                  </div>
                  <div className='item13'>
                    <div className='tick6'>
                      <Check width={15} height={24} strokeWidth={3} />
                    </div>
                    <div className='text-regular-16 text-gray-200'>Reputable SourceOffering credit report and identity theft monitoring for many years</div>
                  </div>
                  <div className='item13'>
                    <div className='tick6'>
                      <Check width={15} height={24} strokeWidth={3} />
                    </div>
                    <div className='text-regular-16 text-gray-200'>Customers can cancel services anytime</div>
                  </div>
                  <Button
                    className='btn btn-lg btn-primary w-100 mt-auto'
                    onClick={() => {
                      setReportData({ ...reportData, report_type: '7' });
                      reportLoginButton();
                    }}>
                    <div>I already have an account</div>
                  </Button>
                  <button onClick={() => showSignupModal('Truly ID', '7', 'https://trulyid.com/signup412ar.asp?GUID=QZ0532B5ZYIJ&tGUID=74EEBC14-A967-4158-8093-094206A3037D/')} className='btn btn-lg btn-outline-primary w-100'>
                    <div>Sign up for Truly ID</div>
                  </button>
                </div>
              </Card.Body>
            </Card>
          </div> */}
        </div>
      </div>

      <Modal show={showLoginModal} onHide={() => setShowLoginModal(false)} backdrop='static' keyboard={false} aria-labelledby='contained-modal-title-vcenter' centered>
        <Modal.Header className='border-0' closeButton></Modal.Header>
        <Modal.Body className='px-4'>
          <ReportUpload setShowLoader={setShowLoader} isNagative={true} id={1} reportData={reportData} setReportData={setReportData} reportDataRef={reportDataRef} isLogin={showLoginModal} closeModel={setShowLoginModal} gotoDashboard={gotoDashboard} />
        </Modal.Body>
      </Modal>

      <Modal show={showReportModal} backdrop='static' keyboard={false} aria-labelledby='contained-modal-title-vcenter' centered>
        <Modal.Body>
          <ReportUpload setShowLoader={setShowLoader} isNagative={true} id={1} reportData={reportData} setReportData={setReportData} reportDataRef={reportDataRef} isLogin={showLoginModal} closeModel={setShowReportModal} gotoDashboard={gotoDashboard} />
        </Modal.Body>
      </Modal>

      <Modal show={showLoader} backdrop='static' keyboard={false} aria-labelledby='contained-modal-title-vcenter' centered size='sm'>
        <Modal.Body>
          <Loader sm={12} />
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

export default ChooseReport;
